import * as React from "react";

import { Root } from "./Hr.styles";

interface HrProps {
    kind?: "dashed";
    width?: "page";
}

export function Hr(props: HrProps): JSX.Element {
    return <Root dashed={props.kind === "dashed"} page={props.width === "page"} />;
}
